import {
  Dialog,
  Button,
  Typography,
  Box,
  TextField,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import React, { useMemo, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { AddBaseDialogStyle as styles } from "./AddBaseDialogStyle";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { pendingShipmentUpdatedFlagState } from "../recoil/atoms/pendingShipmentAtoms";
import { baseSearchOptionsSelector } from "../recoil/selectors/baseSearchOptionsSelector";
import { BaseListItem } from "./Table/BaseListTable";

type Props = {
  open: boolean;
  onClose: () => void;
  onResiter: (updatedUser: BaseListItem) => void;
  statusId: number;
};

const AddBaseDialog: React.FC<Props> = ({ open, onClose, onResiter }) => {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState<"success" | "error">(
    "success"
  );
  const handleCloseToast = () => setToastOpen(false);

  const [baseNmae, setBaseName] = useState("");
  const [mailAddress, setMailAddress] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [postNum, setPostNum] = useState("");
  const [address, setAddress] = useState("");
  const [editBaseInfo, setEditBaseInfo] = useState<BaseListItem>();
  const [selectedBaseId, setSelectedBaseId] = useState<number | null>(null);

  const resetFields = () => {
    setBaseName("");
    setMailAddress("");
    setPhoneNum("");
    setPostNum("");
    setAddress("");
    setEditBaseInfo(undefined);
  };

  const validateCheck = () => {
    return (
      baseNmae.trim() === "" || mailAddress.trim() === ""
      // phoneNum.trim() === "" ||
      // postNum.trim() === "" ||
      // address.trim() === ""
    );
  };

  // 入力欄データまとめ（拠点除く）
  const inputItems: [
    string,
    string,
    React.Dispatch<React.SetStateAction<string>>,
    keyof BaseListItem
  ][] = [
    ["拠点名", baseNmae, setBaseName, "baseName"],
    ["代表メールアドレス", mailAddress, setMailAddress, "mailAddress"],
    ["代表電話番号", phoneNum, setPhoneNum, "phoneNum"],
    ["郵便番号", postNum, setPostNum, "postNum"],
    ["住所", address, setAddress, "address"],
  ];

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
        <Dialog
          open={open}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") onClose();
          }}
          disableEnforceFocus
          maxWidth={false}
          fullWidth={false}
          PaperProps={{
            sx: {
              display: "flex",
              width: "800px",
              height: "500px",
              maxWidth: "none",
              maxHeight: "none",
              overflowY: "auto",
            },
          }}
        >
          <Box sx={styles.header}>
            <Typography sx={styles.headerText}>新規拠点登録</Typography>
            <Button
              onClick={() => {
                resetFields();
                onClose();
              }}
              sx={styles.closeButton}
            >
              ×
            </Button>
          </Box>

          <Box sx={styles.formArea}>
            {inputItems.map(([label, value, setter, key]) => (
              <Box key={label} sx={styles.inputRow}>
                <Typography sx={styles.label}>{label}：</Typography>
                <TextField
                  size="medium"
                  value={value}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    setter(newValue);
                    setEditBaseInfo((prev) => ({
                      ...prev!,
                      [key]: newValue,
                    }));
                  }}
                  sx={{ width: "500px" }}
                />
              </Box>
            ))}
          </Box>

          <Button
            onClick={() => {
              onResiter(editBaseInfo!);
            }}
            variant="contained"
            sx={styles.floatingRegisterButton}
            disabled={validateCheck()}
          >
            登録
          </Button>

          <Snackbar
            open={toastOpen}
            autoHideDuration={4000}
            onClose={handleCloseToast}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={handleCloseToast}
              severity={toastSeverity}
              sx={{ width: "100%" }}
              elevation={6}
              variant="filled"
            >
              {toastMessage}
            </MuiAlert>
          </Snackbar>
        </Dialog>
      </LocalizationProvider>
    </>
  );
};

export default AddBaseDialog;
